import { render, staticRenderFns } from "./employerindustry.vue?vue&type=template&id=665ed46a&"
import script from "./employerindustry.vue?vue&type=script&lang=js&"
export * from "./employerindustry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports